// Prevent redeclaration if script is loaded multiple times
if (typeof window.ProductCalculatorClass === 'undefined') {
  window.ProductCalculatorClass = class ProductCalculator {
    constructor() {
      this.resetFields();
      this.bindEvents();
      this.syncPricesAfterInit();
    }

  resetFields() {
    // Reset main product fields
    document.querySelectorAll('[id*=area_needed]').forEach(el => el.value = "");
    document.querySelectorAll('.product_price_overage_new').forEach(el => el.textContent = "");
    document.querySelectorAll('.qty').forEach(el => el.value = 1);
    const sampleQty = document.querySelector('[id*=sample_quantity]');
    if (sampleQty) sampleQty.value = 1;
    
    // Reset calculator fields (respect product minimum quantity when set)
    const minQty = this.getProductMinQuantity ? this.getProductMinQuantity() : 1;
    document.querySelectorAll('#ft_need').forEach(el => el.value = "");
    document.querySelectorAll('#finalquantity').forEach(el => {
      el.value = minQty;
      if (minQty > 1) el.min = String(minQty);
    });
  }

  bindEvents() {
    // Overage checkbox change handler
    document.addEventListener('change', (e) => {
      if (e.target.matches('#overage_checkbox')) {
        this.handleOverageCheckbox(e.target.checked);
      }
      if (e.target.matches('input[name="overage_percent"]')) {
        this.handleOveragePercentChange();
      }
    });

    // Main product area needed input
    document.addEventListener('change', (e) => {
      if (e.target.matches('#ft_need')) {
        this.handleAreaNeeded(e.target.value, e.target);
      }
      if (e.target.matches('#finalquantity')) {
        // Check if this change was triggered by user input (not programmatic)
        if (e.target === document.activeElement) {
          this.handleManualFinalQuantityChange(e.target.value);
        } else {
          this.handleFinalQuantity(e.target.value);
        }
      }
    });
    document.addEventListener('keyup', (e) => {
      if (e.target.matches('#ft_need')) {
        this.handleAreaNeeded(e.target.value, e.target);
      }
      if (e.target.matches('#finalquantity')) {
        // Check if this change was triggered by user input (not programmatic)
        if (e.target === document.activeElement) {
          this.handleManualFinalQuantityChange(e.target.value);
        } else {
          this.handleFinalQuantity(e.target.value);
        }
      }
    });
    // Modal area needed input
    document.addEventListener('change', (e) => {
      if (e.target.closest('.modal__inner [id*=ft_need-modal]')) {
        this.handleModalAreaNeeded(e);
      }
    });
    document.addEventListener('keyup', (e) => {
      if (e.target.closest('.modal__inner [id*=ft_need-modal]')) {
        this.handleModalAreaNeeded(e);
      }
    });
    
    // Listen for variant changes
    document.addEventListener('variant:change', () => {
      this.handleVariantChange();
    });
    
    // Also listen for custom variant change events
    document.addEventListener('variant:updated', () => {
      this.handleVariantChange();
    });
    
    // Listen for Alpine.js variant changes
    document.addEventListener('alpine:init', () => {
      if (window.Alpine) {
        window.Alpine.store('xVariantSelect', {
          ...window.Alpine.store('xVariantSelect'),
          onVariantChange: () => {
            this.handleVariantChange();
          }
        });
      }
    });
    
    // Listen for custom variant change events from the theme (section-scoped)
    const calculatorSectionId = document.querySelector('.calculator-wrapper')
      ?.closest('[id^="shopify-section-"]')?.id?.replace('shopify-section-', '');
    if (calculatorSectionId) {
      document.addEventListener(`eurus:product-page-variant-select:updated:${calculatorSectionId}`, () => {
        this.handleVariantChange();
      });
    }
    
    document.addEventListener('eurus:product-card-variant-select:updated', () => {
      this.handleVariantChange();
    });

    document.addEventListener('wpd:trade-price-ready', () => {
      this._cancelVariantPriceTimers();
      this.updateAllPrices();
    });

    document.addEventListener('wpd:calculator-price-synced', () => {
      this._cancelVariantPriceTimers();
      this.updateAllPrices();
    });
    
    // Listen for quantity picker changes
    document.addEventListener('change', (e) => {
      if (e.target.matches('input[name="quantity"]') && e.target.closest('.quantity-selector-container')) {
        this.handleQuantityPickerChange(e.target.value);
      }
    });
    
    // Also listen for direct Alpine.js qty changes (plus/minus buttons)
    document.addEventListener('click', (e) => {
      if (e.target.closest('button[name="plus"], button[name="minus"]') && 
          e.target.closest('.quantity-selector-container')) {
        const container = e.target.closest('.quantity-selector-container');
        // Prefer Alpine qty (already updated) over delayed input read
        requestAnimationFrame(() => {
          let qty = null;
          try {
            qty = window.Alpine?.$data?.(container)?.qty;
          } catch (_) {}
          const qtyInput = container.querySelector('input[name="quantity"]');
          if (qty == null && qtyInput) qty = qtyInput.value;
          if (qty != null) this.handleQuantityPickerChange(qty);
        });
      }
    });

  }

  toggleNewOverageDropdown(dd) {
    if (!dd) return;
    const isOpen = dd.getAttribute('data-open') === '1';
    if (isOpen) {
      this.closeNewOverageDropdown(dd);
      return;
    }
    document.querySelectorAll('[data-calculator-new-overage][data-open="1"]').forEach((other) => {
      if (other !== dd) this.closeNewOverageDropdown(other);
    });
    dd.setAttribute('data-open', '1');
    const list = dd.querySelector('.calculator-overage-dd__list');
    const trigger = dd.querySelector('.calculator-overage-dd__trigger');
    if (list) list.hidden = false;
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
  }

  closeNewOverageDropdown(dd) {
    if (!dd || dd.getAttribute('data-open') !== '1') return;
    dd.setAttribute('data-open', '0');
    const list = dd.querySelector('.calculator-overage-dd__list');
    const trigger = dd.querySelector('.calculator-overage-dd__trigger');
    if (list) list.hidden = true;
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  applyNewOverageOption(dd, optBtn) {
    if (!dd || !optBtn) return;
    const val = optBtn.getAttribute('data-value') || '0';
    const labelText = optBtn.getAttribute('data-label') || optBtn.textContent.trim();
    const hidden = dd.querySelector('.js-calculator-new-overage-value');
    const labelEl = dd.querySelector('.js-calculator-new-overage-label');
    if (hidden) hidden.value = val;
    if (labelEl) labelEl.textContent = labelText;
    dd.querySelectorAll('.calculator-overage-dd__opt').forEach((btn) => {
      btn.setAttribute('aria-selected', btn === optBtn ? 'true' : 'false');
    });
    this.closeNewOverageDropdown(dd);
    this.handleNewCalculatorOverageChange();
  }

  handleNewCalculatorOverageChange() {
    const newRoot = document.querySelector('.calculator-block--new');
    const ftNeedInput = newRoot?.querySelector('#ft_need');
    if (ftNeedInput && ftNeedInput.value) {
      this.handleAreaNeeded(ftNeedInput.value, ftNeedInput);
    }
  }

  handleFinalQuantity(val) {
    if (!val) return;
    const qty = this.enforceMinBoxes(val);
    const v_id = this.getInputValueByName('id');
    const variant = window.meta?.product?.variants?.find(item => String(item.id) === String(v_id));
    
    // Update finalquantity inputs
    document.querySelectorAll('#finalquantity').forEach(el => {
      el.value = qty;
      el.min = String(this.getProductMinQuantity());
    });
    
    // Update quantity picker inputs
    document.querySelectorAll('.product__quantity input[name="quantity"], .quantity-selector-container input[name="quantity"]').forEach(el => {
      el.value = qty;
      const minQty = this.getProductMinQuantity();
      if (minQty > 1) el.min = String(minQty);
    });
    
    // Update Alpine.js quantity picker data
    this.updateAlpineQuantity(qty);
    
    if (variant) {
      const effectivePrices = this.getEffectiveCalculatorPrices(variant);
      if (effectivePrices.pendingTradePrice || effectivePrices.price === null) {
        return;
      }
      const { price } = effectivePrices;
      const total_price = parseFloat(price * qty);
      const tot_price = this.formatMoney(total_price);
      document.querySelectorAll('.total-value').forEach(el => {
        el.innerHTML = tot_price;
      });
    }
    this.updateTotalSummaryLine();
  }

  getProductMinQuantity() {
    if (this.isSelectedVariantSample()) {
      return 1;
    }
    const forms = document.querySelectorAll('form[data-type="add-to-cart-form"][data-min-quantity]');
    for (const form of forms) {
      const raw = form.dataset?.minQuantity ?? form.getAttribute('data-min-quantity');
      const parsed = parseInt(raw, 10);
      if (Number.isFinite(parsed) && parsed > 0) {
        return parsed;
      }
    }
    const qtyInput = document.querySelector('.quantity-selector-container input[name="quantity"]');
    const inputMin = parseInt(qtyInput?.min, 10);
    if (Number.isFinite(inputMin) && inputMin > 0) {
      return inputMin;
    }
    return 1;
  }

  isSelectedVariantSample() {
    const checkedQty = document.querySelector(
      'input[type="radio"][name="Quantity"]:checked, input[type="radio"][name^="Quantity-"]:checked'
    );
    const selectQty = document.querySelector('select[name="Quantity"], select[name^="Quantity-"]');
    const label = String(
      checkedQty?.value ||
        selectQty?.selectedOptions?.[0]?.textContent ||
        selectQty?.value ||
        ''
    ).toLowerCase();
    if (
      label.includes('sample') ||
      label.includes('single tile') ||
      label.includes('single sheet') ||
      label.includes('full sheet')
    ) {
      return true;
    }

    const qtyInput = document.querySelector('.quantity-selector-container input[name="quantity"]');
    const alpineData = qtyInput?.closest?.('.quantity-selector-container')?._x_dataStack?.[0];
    if (alpineData?.hasSampleLimit) {
      return true;
    }
    return false;
  }

  enforceMinBoxes(boxes) {
    const parsed = parseInt(boxes, 10);
    const safeBoxes = Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
    const minQty = this.getProductMinQuantity();
    return Math.max(safeBoxes, minQty);
  }

  handleAreaNeeded(val, sourceEl = null) {
    if (!val) return;
    const root =
      sourceEl?.closest?.('.calculator-wrapper') ||
      document.querySelector('.calculator-block--new') ||
      document.querySelector('.calculator-wrapper');
    const actual_area_el =
      root?.querySelector('#area_actual') || document.querySelector('#area_actual');
    if (!actual_area_el) return;
    const actual_area = parseFloat(actual_area_el.innerHTML);
    let base_sq_ft = parseFloat(val);
    let total_sq_ft_needed = base_sq_ft;

    let overagePercent = 0;
    const newOverageHidden = root?.querySelector('.js-calculator-new-overage-value');
    if (newOverageHidden) {
      const parsed = parseFloat(newOverageHidden.value, 10);
      overagePercent = Number.isFinite(parsed) ? parsed : 0;
    } else {
      const overageCheckbox =
        root?.querySelector('#overage_checkbox') || document.querySelector('#overage_checkbox');
      if (overageCheckbox && overageCheckbox.checked) {
        const selectedPercent =
          root?.querySelector('input[name="overage_percent"]:checked') ||
          document.querySelector('input[name="overage_percent"]:checked');
        overagePercent = selectedPercent ? parseFloat(selectedPercent.value) : 20;
      }
    }
    if (overagePercent > 0) {
      total_sq_ft_needed = base_sq_ft * (1 + overagePercent / 100);
    }

    total_sq_ft_needed = Number(total_sq_ft_needed.toFixed(2));
    const SQ_FT_per_box = Number(actual_area.toFixed(2));
    let tot_num_boxes = Number((total_sq_ft_needed / SQ_FT_per_box).toFixed(2));
    if (tot_num_boxes) {
      // Update finalquantity input
      tot_num_boxes = this.enforceMinBoxes(Math.ceil(tot_num_boxes));
      document.querySelectorAll('#finalquantity').forEach(el => {
        el.value = tot_num_boxes;
        el.min = String(this.getProductMinQuantity());
      });
      document.querySelectorAll('.product__quantity input[name="quantity"], .quantity-selector-container input[name="quantity"]').forEach(el => {
        el.value = tot_num_boxes;
        const minQty = this.getProductMinQuantity();
        if (minQty > 1) el.min = String(minQty);
      });

      // Update Alpine.js quantity picker data
      this.updateAlpineQuantity(tot_num_boxes);
      const v_id = this.getInputValueByName('id');
      const variant = window.meta?.product?.variants?.find(item => String(item.id) === String(v_id));
      if (variant) {
        const effectivePrices = this.getEffectiveCalculatorPrices(variant);
        if (effectivePrices.pendingTradePrice || effectivePrices.price === null) {
          return;
        }
        const { price } = effectivePrices;
        const total_price = parseFloat(price * tot_num_boxes);
        const tot_price = this.formatMoney(total_price);
        document.querySelectorAll('.total-value').forEach(el => {
          el.innerHTML = tot_price;
        });

        // Update price per sq. ft. display
        // Prefer main price /sqft so calculator stays in sync.
        if (actual_area > 0) {
          const mainSqftEl = document.querySelector('.main-product-price__sqft-value');
          let wroteMainSqft = false;
          if (mainSqftEl) {
            const clone = mainSqftEl.cloneNode(true);
            clone.querySelectorAll('s, .wpd-ext-compare-at-price').forEach((node) => node.remove());
            const mainSqftText = (clone.textContent || '').trim();
            if (mainSqftText) {
              document.querySelectorAll('.js-calculator-sqft-value').forEach((el) => {
                el.textContent = mainSqftText;
              });
              wroteMainSqft = true;
            }
          }
          if (!wroteMainSqft) {
            const sqftBasis = this.getSqftBasisVariant(variant);
            const sqftBasisPrices = this.getEffectiveCalculatorPrices(sqftBasis);
            if (!sqftBasisPrices.pendingTradePrice && sqftBasisPrices.price !== null) {
              const sqft_price = Math.round(sqftBasisPrices.price / actual_area);
              const formatted_sqft_price = this.formatMoney(sqft_price);
              document.querySelectorAll('.js-calculator-sqft-value').forEach(el => {
                el.textContent = formatted_sqft_price;
              });
            }
          }
        }
      }
      this.updateTotalSummaryLine();
    }
  }

  handleModalAreaNeeded(e) {
    e.preventDefault();
    const input = e.target;
    const _parent = input.closest('.modal__centered-content');
    if (!_parent) return;
    const currentValue = input.value;
    if (!currentValue) return;
    const actual_area = parseFloat(_parent.querySelector('[id*=area_actual-modal]')?.textContent || 0);
    const overage_sq_ft = parseFloat(currentValue);
    const total_sq_ft_needed = Number(overage_sq_ft.toFixed(2));
    const SQ_FT_per_box = Number(actual_area.toFixed(2));
    let tot_num_boxes = Number((total_sq_ft_needed / SQ_FT_per_box).toFixed(2));
    if (tot_num_boxes) {
      _parent.querySelectorAll('[id*=pp_overage_new_1-modal]').forEach(el => el.textContent = tot_num_boxes);
      tot_num_boxes = this.enforceMinBoxes(Math.ceil(tot_num_boxes));
      _parent.querySelectorAll('[id*=finalquantity-modal]').forEach(el => el.value = tot_num_boxes);
      _parent.querySelectorAll('.js-qty__wrapper input[name="quantity"]').forEach(el => el.value = tot_num_boxes);
      const v_id = _parent.querySelector('[name="name"]')?.value;
      const pId = _parent.querySelector('.product-section')?.getAttribute('data-product-id');
      if (!pId) return;
      const jsonEl = _parent.querySelector(`#wcp_json_${pId}-modal`);
      if (!jsonEl) return;
      let productDetails;
      try {
        productDetails = JSON.parse(jsonEl.textContent);
      } catch {
        return;
      }
      const variant = productDetails.variants.find(item => String(item.id) === String(v_id));
      if (variant) {
        const price = variant.price;
        const total_price = parseFloat(price * tot_num_boxes);
        const tot_price = this.formatMoney(total_price);
        _parent.querySelectorAll('[id*=total_price_2-modal]').forEach(el => {
          el.innerHTML = `<span class="amount">${tot_price}</span>`;
        });
      }
    }
  }

  handleVariantChange() {
    this._cancelVariantPriceTimers();
    this._variantPriceTimers = [];

    // One immediate pass + one short WPD catch-up (was 100/200/600/1200 → flicker).
    this.updateAllPrices();
    this._variantPriceTimers.push(setTimeout(() => this.updateAllPrices(), 350));

    setTimeout(() => {
      this.resetFields();
    }, 100);
  }

  _cancelVariantPriceTimers() {
    if (!this._variantPriceTimers) return;
    this._variantPriceTimers.forEach((timerId) => clearTimeout(timerId));
    this._variantPriceTimers = [];
  }

  updateAllPrices() {
    const calculatorWrapper = document.querySelector('.calculator-wrapper');
    if (!calculatorWrapper) return;
    
    const areaActual = parseFloat(calculatorWrapper.getAttribute('data-area-actual') || 0);
    const currentVariant = this.getCurrentVariant();
    
    if (currentVariant && areaActual > 0) {
      const effectivePrices = this.getEffectiveCalculatorPrices(currentVariant);
      if (effectivePrices.pendingTradePrice || effectivePrices.price === null) {
        document.querySelectorAll('.price_per_box').forEach((priceBox) => {
          priceBox.setAttribute('data-wpd-variant-id', String(currentVariant.id));
        });
        return;
      }

      const { price, compareAtPrice } = effectivePrices;
      const hasComparePrice = compareAtPrice && compareAtPrice > price;
      
      // Prefer main product /sqft so calculator matches the headline price.
      const mainSqftEl = document.querySelector('.main-product-price__sqft-value');
      let wroteMainSqft = false;
      if (mainSqftEl) {
        const clone = mainSqftEl.cloneNode(true);
        clone.querySelectorAll('s, .wpd-ext-compare-at-price').forEach((node) => node.remove());
        const mainSqftText = (clone.textContent || '').trim();
        if (mainSqftText) {
          document.querySelectorAll('.js-calculator-sqft-value').forEach((el) => {
            el.textContent = mainSqftText;
          });
          wroteMainSqft = true;
        }
      }

      if (!wroteMainSqft) {
        // PDP fix 2026-07-12: per-sqft must use a BOX variant's price (see box-calculator-new.liquid).
        const sqftBasisUAP = this.getSqftBasisVariant(currentVariant);
        const sqftBasisPricesUAP = this.getEffectiveCalculatorPrices(sqftBasisUAP);
        if (!sqftBasisPricesUAP.pendingTradePrice && sqftBasisPricesUAP.price !== null) {
          const sqftPrice = Math.round(sqftBasisPricesUAP.price / areaActual);
          const formattedSqftPrice = this.formatMoney(sqftPrice);
          document.querySelectorAll('.js-calculator-sqft-value').forEach(el => {
            el.textContent = formattedSqftPrice;
          });
        }
      }
      
      // Update Price per Box and compare price
      const formattedBoxPrice = this.formatMoney(price);
      document.querySelectorAll('.price_per_box').forEach(priceBox => {
        const productHandle = priceBox.getAttribute('data-wpd-product-handle');
        const productId = priceBox.getAttribute('data-wpd-product-id');
        const shouldKeepProcessed = priceBox.classList.contains('wpd-processed') || this.isTradeCustomer();

        priceBox.textContent = formattedBoxPrice;
        priceBox.setAttribute('data-wpd-variant-id', String(currentVariant.id));
        priceBox.setAttribute('data-wpd-variant-price', Math.round(price));
        priceBox.setAttribute('data-wpd-variant-compare-at-price', Math.round(compareAtPrice || 0));
        priceBox.style.visibility = 'visible';

        if (productHandle) {
          priceBox.setAttribute('data-wpd-product-handle', productHandle);
        }
        if (productId) {
          priceBox.setAttribute('data-wpd-product-id', productId);
        }
        if (shouldKeepProcessed) {
          priceBox.classList.add('wpd-processed');
        }
        
        // Update styling based on compare price
        if (hasComparePrice) {
          priceBox.style.color = 'rgb(177, 77, 77)';
        } else {
          priceBox.style.color = '';
        }
        
        // Find the parent calculator-value div
        const parentDiv = priceBox.closest('.calculator-value');
        if (parentDiv) {
          // Find or create compare price element
          let comparePriceEl = parentDiv.querySelector('[data-compare-price-2]');
          
          if (hasComparePrice) {
            const formattedComparePrice = this.formatMoney(compareAtPrice);
            if (!comparePriceEl) {
              // Create compare price element if it doesn't exist
              comparePriceEl = document.createElement('strike');
              comparePriceEl.setAttribute('data-compare-price-2', '');
              comparePriceEl.className = 'product__price--compare pr-1';
              comparePriceEl.style.color = 'gray';
              parentDiv.insertBefore(comparePriceEl, priceBox);
            }
            comparePriceEl.textContent = formattedComparePrice;
            comparePriceEl.style.display = '';
          } else if (comparePriceEl) {
            // Hide compare price if it exists but shouldn't be shown
            comparePriceEl.style.display = 'none';
          }
        }
      });
      
      // Update Total Price if there's a current quantity
      const currentQuantity = document.querySelector('#finalquantity')?.value || 1;
      if (currentQuantity > 0) {
        const totalPrice = price * currentQuantity;
        const formattedTotalPrice = this.formatMoney(totalPrice);
        document.querySelectorAll('.total-value').forEach(el => {
          el.innerHTML = formattedTotalPrice;
        });
      }

      this.updateTotalSummaryLine();
    }
  }

  getCurrentVariant() {
    const v_id = this.getInputValueByName('id');
    if (!v_id) return null;
    
    // Try to get variant from window.meta first
    if (window.meta?.product?.variants) {
      const variant = window.meta.product.variants.find(item => String(item.id) === String(v_id));
      if (variant) return variant;
    }
    
    // Fallback: try to get from product JSON
    const productJson = document.querySelector('#ProductJson-product-template');
    if (productJson) {
      try {
        const productData = JSON.parse(productJson.textContent);
        const variant = productData.variants.find(item => String(item.id) === String(v_id));
        if (variant) return variant;
      } catch (e) {
        // Silent error handling for production
      }
    }
    
    return null;
  }

  getTilesPerBox() {
    const wrap = document.querySelector('.calculator-wrapper');
    const raw = String(wrap?.dataset?.tilesPerBox || '').trim();
    const fallback = parseInt(raw, 10);
    const safeFallback = Number.isFinite(fallback) && fallback > 0 ? fallback : 0;

    const variant = this.getCurrentVariant();
    if (!variant) return safeFallback;

    const opts = [variant.option1, variant.option2, variant.option3].filter(Boolean);
    for (let i = 0; i < opts.length; i += 1) {
      const m = String(opts[i]).match(/box of\s*(\d+)/i);
      if (m) return parseInt(m[1], 10);
    }
    return safeFallback;
  }

  formatPiecePhrase(count, noun) {
    const n = noun || 'pieces';
    if (count === 1) {
      if (n === 'sheets') return '1 sheet';
      if (n === 'pieces') return '1 piece';
      if (n === 'tiles') return '1 tile';
      return `1 ${n}`;
    }
    return `${count} ${n}`;
  }

  updateTotalSummaryLine() {
    const wrap = document.querySelector('.calculator-wrapper');
    if (!wrap) return;

    const areaEl = document.querySelector('#area_actual');
    const qtyInput = document.querySelector('#finalquantity');
    if (!areaEl || !qtyInput) return;

    const sqftPerBox = parseFloat(String(areaEl.textContent || areaEl.innerHTML).trim());
    if (!Number.isFinite(sqftPerBox) || sqftPerBox <= 0) return;

    const parsedQty = parseInt(qtyInput.value, 10);
    const boxes = parsedQty > 0 ? parsedQty : 1;

    const covered = Math.round(boxes * sqftPerBox * 100) / 100;
    const tilesPerBox = this.getTilesPerBox();
    const pieceNoun = wrap.dataset.pieceNoun || 'pieces';

    const boxWord = boxes === 1 ? 'box' : 'boxes';
    let text = `total: ${boxes} ${boxWord} will cover ${covered} sq. ft.`;

    if (tilesPerBox > 0) {
      const totalPieces = boxes * tilesPerBox;
      text += ` (${this.formatPiecePhrase(totalPieces, pieceNoun)})`;
    }

    document.querySelectorAll('.js-calculator-total-summary').forEach((el) => {
      el.textContent = text;
    });
  }

  getInputValueByName(name) {
    const calculatorWrapper = document.querySelector('.calculator-wrapper');
    const sectionEl = calculatorWrapper?.closest('[id^="shopify-section-"]');
    const sectionId = sectionEl?.id?.replace('shopify-section-', '');

    if (sectionId) {
      const scopedInput = document.querySelector(
        `#product-form-${sectionId} [name="${name}"], #product-form-sticky-${sectionId} [name="${name}"], #product-form-installment-${sectionId} [name="${name}"]`
      );
      if (scopedInput) return scopedInput.value;
    }

    const addToCartInput = document.querySelector(`form[action*="/cart/add"] [name="${name}"]`);
    if (addToCartInput) return addToCartInput.value;

    const el = document.querySelector(`[name="${name}"]`);
    return el ? el.value : null;
  }

  formatMoney(amount) {
    if (window.theme?.Currency?.formatMoney && window.theme?.settings?.moneyFormat) {
      return window.theme.Currency.formatMoney(amount, window.theme.settings.moneyFormat);
    }
    // fallback
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'USD'
    }).format(amount / 100); // Shopify price is in cents
  }

  parsePriceToCents(value) {
    if (value === null || value === undefined) return null;
    if (typeof value === 'number' && Number.isFinite(value)) {
      return Math.round(value);
    }

    const normalized = String(value).replace(/[^0-9.,-]/g, '');
    if (!normalized) return null;
    const standardized = normalized.includes('.') ? normalized.replace(/,/g, '') : normalized.replace(',', '.');
    const amount = parseFloat(standardized);
    if (!Number.isFinite(amount)) return null;
    return Math.round(amount * 100);
  }

  isTradeCustomer() {
    return Boolean(window.shopifyCustomer || window.wcp_customer?.tags?.length);
  }

  getCalculatorSectionRoot() {
    return document.querySelector('.calculator-wrapper')?.closest('[id^="shopify-section-"]') || document;
  }

  getDisplayedCalculatorPrices(fallbackPrice, fallbackCompareAtPrice) {
    const priceBox = document.querySelector('.price_per_box');
    if (!priceBox) {
      return {
        price: fallbackPrice,
        compareAtPrice: fallbackCompareAtPrice
      };
    }

    const compareFromStrike = priceBox.querySelector('s, .wpd-ext-compare-at-price');
    const compareFromParent = priceBox.closest('.calculator-value')?.querySelector('[data-compare-price-2]');
    let compareAtPrice = this.parsePriceToCents(compareFromStrike?.textContent)
      || this.parsePriceToCents(compareFromParent?.textContent)
      || fallbackCompareAtPrice;

    const clone = priceBox.cloneNode(true);
    clone.querySelectorAll('s, .wpd-ext-compare-at-price').forEach((node) => node.remove());
    let price = this.parsePriceToCents(clone.textContent);

    if (!price || price <= 0) {
      price = this.parsePriceToCents(priceBox.textContent);
    }
    if (!price || price <= 0) {
      price = fallbackPrice;
    }

    if (!compareAtPrice || compareAtPrice <= price) {
      compareAtPrice = fallbackCompareAtPrice;
    }

    return {
      price,
      compareAtPrice
    };
  }

  // PDP fix 2026-07-12: the "Per sq. ft." figure must be computed from a BOX variant.
  // The selected variant is usually the Single Tile (sample), whose price divided by
  // the box's sqft coverage understates the real per-sqft cost by 10-30x.
  getSqftBasisVariant(variant) {
    if (!variant) return variant;
    if ((variant.title || '').includes('Box')) return variant;
    const variants = window.meta?.product?.variants || [];
    const sameColorBox = variants.find(v => (v.public_title || v.title || '').includes('Box')
      && v.option1 === variant.option1);
    if (sameColorBox) return sameColorBox;
    const anyBox = variants.find(v => (v.public_title || v.title || '').includes('Box'));
    return anyBox || variant;
  }

  getEffectiveCalculatorPrices(variant) {
    const fallbackPrice = parseFloat(variant?.price) || 0;
    const fallbackCompareAtPrice = variant?.compare_at_price ? parseFloat(variant.compare_at_price) : null;
    const sectionRoot = this.getCalculatorSectionRoot();

    if (this.isTradeCustomer() && typeof window.wpdGetTradeBoxPriceForVariant === 'function') {
      const tradePrice = window.wpdGetTradeBoxPriceForVariant(variant?.id, sectionRoot);
      if (tradePrice) {
        return tradePrice;
      }
    }

    const displayed = this.getDisplayedCalculatorPrices(fallbackPrice, fallbackCompareAtPrice);
    const priceBox = document.querySelector('.price_per_box');

    if (!priceBox) {
      return displayed;
    }

    const hasWholesaleMarkup = priceBox.classList.contains('wpd-processed')
      || Boolean(priceBox.querySelector('.wpd-ext-compare-at-price'));
    const hasTradePriceDelta = Math.abs((displayed.price || 0) - fallbackPrice) > 1;
    const displayedVariantId = priceBox.dataset?.wpdVariantId;
    const isDisplayedForCurrentVariant = displayedVariantId
      ? String(displayedVariantId) === String(variant?.id)
      : false;

    if ((hasWholesaleMarkup || hasTradePriceDelta) && isDisplayedForCurrentVariant) {
      return displayed;
    }

    if (this.isTradeCustomer()) {
      return {
        price: null,
        compareAtPrice: null,
        pendingTradePrice: true
      };
    }

    return {
      price: fallbackPrice,
      compareAtPrice: fallbackCompareAtPrice
    };
  }

  // Update Alpine.js quantity picker value
  updateAlpineQuantity(quantity) {
    // Find the quantity selector container and try to update the Alpine.js data
    const qtyContainer = document.querySelector('.quantity-selector-container');
    const intQuantity = parseInt(quantity, 10);
    const minQty = this.getProductMinQuantity();
    if (qtyContainer && window.Alpine) {
      // Get the Alpine component data
      const alpineData = window.Alpine.$data(qtyContainer);
      if (alpineData) {
        if (typeof alpineData.min !== 'undefined' && minQty > 1) {
          alpineData.min = minQty;
        }
        if (typeof alpineData.qty !== 'undefined') {
          alpineData.qty = intQuantity;
        }
      }
    }
  }

  // Handle quantity picker changes and sync to calculator
  handleQuantityPickerChange(quantity) {
    if (!quantity || quantity < 1) return;
    
    const intQuantity = this.enforceMinBoxes(quantity);
    
    // Update finalquantity inputs without triggering calculator recalculation
    document.querySelectorAll('#finalquantity').forEach(el => {
      if (el.value != intQuantity) {
        el.value = intQuantity;
      }
    });
    
    // Update total price based on new quantity
    this.updateTotalPrice(intQuantity);
  }

  // Update total price in calculator
  updateTotalPrice(quantity) {
    const v_id = this.getInputValueByName('id');
    const variant = window.meta?.product?.variants?.find(item => String(item.id) === String(v_id));
    if (variant) {
      const effectivePrices = this.getEffectiveCalculatorPrices(variant);
      if (effectivePrices.pendingTradePrice || effectivePrices.price === null) {
        return;
      }
      const { price } = effectivePrices;
      const total_price = parseFloat(price * quantity);
      const tot_price = this.formatMoney(total_price);
      document.querySelectorAll('.total-value').forEach(el => {
        el.innerHTML = tot_price;
      });
    }
    this.updateTotalSummaryLine();
  }

  // Handle manual changes to finalquantity input and sync to quantity picker
  handleManualFinalQuantityChange(quantity) {
    if (!quantity || quantity < 1) return;

    const intQuantity = this.enforceMinBoxes(quantity);

    // Update all finalquantity inputs
    document.querySelectorAll('#finalquantity').forEach(el => {
      el.min = String(this.getProductMinQuantity());
      if (el.value != intQuantity) {
        el.value = intQuantity;
      }
    });

    // Update quantity picker inputs
    document.querySelectorAll('.product__quantity input[name="quantity"], .quantity-selector-container input[name="quantity"]').forEach(el => {
      const minQty = this.getProductMinQuantity();
      if (minQty > 1) el.min = String(minQty);
      if (el.value != intQuantity) {
        el.value = intQuantity;
      }
    });

    // Update Alpine.js quantity picker data
    this.updateAlpineQuantity(intQuantity);

    // Update total price
    this.updateTotalPrice(intQuantity);
  }

  // Handle overage checkbox toggle
  handleOverageCheckbox(isChecked) {
    const overageMessage = document.querySelector('#overage_message');

    if (isChecked) {
      // Show overage message
      if (overageMessage) {
        overageMessage.style.display = 'block';
      }
    } else {
      // Hide overage message
      if (overageMessage) {
        overageMessage.style.display = 'none';
      }
    }

    // Recalculate if there's a value in the input (same calculator block as checkbox)
    const ftWrap = document.querySelector('#overage_checkbox')?.closest('.calculator-wrapper');
    const ftNeedInput =
      ftWrap?.querySelector('#ft_need') ||
      document.querySelector('.calculator-block--new #ft_need') ||
      document.querySelector('#ft_need');
    if (ftNeedInput && ftNeedInput.value) {
      this.handleAreaNeeded(ftNeedInput.value, ftNeedInput);
    }
  }

  // Handle overage percentage change
  handleOveragePercentChange() {
    const selected = document.querySelector('input[name="overage_percent"]:checked');
    const ftWrap = selected?.closest('.calculator-wrapper');
    const ftNeedInput =
      ftWrap?.querySelector('#ft_need') ||
      document.querySelector('.calculator-block--new #ft_need') ||
      document.querySelector('#ft_need');

    // Recalculate if there's a value in the input
    if (ftNeedInput && ftNeedInput.value) {
      this.handleAreaNeeded(ftNeedInput.value, ftNeedInput);
    }
  }

  // Re-sync once DOM and variant scripts settle after initial page load
  syncPricesAfterInit() {
    requestAnimationFrame(() => {
      this.updateAllPrices();
      setTimeout(() => this.updateAllPrices(), 250);
    });
  }
  };
}

function bindCalculatorOverageDropdownEvents() {
  if (window.__calculatorOverageDropdownEventsBound) return;
  window.__calculatorOverageDropdownEventsBound = true;

  document.addEventListener('click', (e) => {
    const calc = window.ProductCalculator;
    if (!calc) return;

    const optBtn = e.target.closest('.calculator-overage-dd__opt');
    if (optBtn) {
      const dd = optBtn.closest('[data-calculator-new-overage]');
      if (dd) {
        calc.applyNewOverageOption(dd, optBtn);
      }
      return;
    }
    if (e.target.closest('.calculator-overage-dd__trigger')) {
      const dd = e.target.closest('[data-calculator-new-overage]');
      if (dd) {
        e.preventDefault();
        calc.toggleNewOverageDropdown(dd);
      }
      return;
    }
    const openDd = document.querySelector('[data-calculator-new-overage][data-open="1"]');
    if (openDd) {
      calc.closeNewOverageDropdown(openDd);
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const calc = window.ProductCalculator;
    if (!calc) return;
    document.querySelectorAll('[data-calculator-new-overage][data-open="1"]').forEach((dd) => {
      calc.closeNewOverageDropdown(dd);
    });
  });
}

function initProductCalculator() {
  if (!window.ProductCalculator) {
    window.ProductCalculator = new window.ProductCalculatorClass();
  } else {
    window.ProductCalculator.syncPricesAfterInit();
  }
}

bindCalculatorOverageDropdownEvents();

// Initialize calculator when DOM is ready (only if not already initialized)
if (!window.ProductCalculator) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductCalculator);
  } else {
    initProductCalculator();
  }

  document.addEventListener('shopify:section:load', initProductCalculator);
} 
